import { HUB_CONNECTION_STATUS, IHubConnectionStatus } from '../../common/hub-client'
import { LOAN_CALCULATOR_PREDEFINED_PERIODS } from '../../components/molecules/LoanOfferSummaryPanelEditable/LoanOfferSummaryPanelEditableProps'
import { AppLinks } from '../../environment/app-links'
import { BmBanksResponse } from "../../models/bm-banks.resposne";
import { IContractDone, IPreparedForDisbursed } from '../../models/credential-actions-models'
import { OffertResponse } from "../../models/prepare.offert.model.dto";
import { affiliatePartnersNames } from '../../pages/AffiliatePage/affiliatePartnersData'
import { MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES } from '../../pages/ManualVerificationPage/models/IManualVerificationPageModel'
import { PREDEFINED_PERIODS_OFFER_LOGIC } from '../types'

export const APPLICATION_CREATED = "APPLICATION_CREATED";
export const CLEAR = "CLEAR";
export const CHANGE_APPLICATION_STATE = "CHANGE_APPLICATION_STATE";
export const PREPARE_APP_REQUEST = "PREPARE_APP_REQUEST";
export const APP_READY = "APP_READY";
export const BANK_VERIFICATION = "BANK_VERIFICATION";
export const GET_BM_BANKS = "GET_BM_BANKS";
export const RETURN_FROM_BM = "RETURN_FROM_BM";
export const APP_OFFLINE = "APP_OFFLINE";
export const APP_ONLINE = "APP_ONLINE";
export const APP_BACK_ONLINE = "APP_BACK_ONLINE";
export const APP_LOADING = "APP_LOADING";
export const APP_END_LOADING = "APP_END_LOADING";
export const APP_CHANGE_LOADING_SCREEN_TEXT = "APP_CHANGE_LOADING_SCREEN_TEXT";
export const HUB_CONNECTED = "HUB_CONNECTED";
export const HUB_DISCONNECTED = "HUB_DISCONNECTED";
export const SET_CONTRACT_DONE_DATA = "SET_CONTRACT_DONE_DATA";
export const SET_HAS_CLIENT_CONSENT_MANUAL_VERIFICATION = "SET_HAS_CLIENT_CONSENT_MANUAL_VERIFICATION";
export const SET_MANUAL_VERIFICATION_HUB_VERIFICATION_STATE = "SET_MANUAL_VERIFICATION_HUB_VERIFICATION_STATE";
export const SET_APP_HAS_ERROR = "SET_APP_HAS_ERROR";
export const SET_USER_TRAPPED_ON_PAGE_URL_PATH = "SET_USER_TRAPPED_ON_PAGE_URL_PATH";
export const SET_HUB_CONNECTION_STATUS = 'SET_HUB_CONNECTION_STATUS'
export const SET_USER_EMAIL_FROM_HUB = 'SET_USER_EMAIL_FROM_HUB'
export const SET_CURRENT_SELECTED_PREDEFINED_PERIOD = "SET_CURRENT_SELECTED_PREDEFINED_PERIOD"
export const SET_IS_PREDEFINED_PERIODS_AVAILABLE = "SET_IS_PREDEFINED_PERIODS_AVAILABLE"


export interface ApplicationCreatedAction {
  type: typeof APPLICATION_CREATED;
  payload: string;
}

export interface ClearApplicationInfo {
  type: typeof CLEAR;
}

export interface ChangeApplicationState {
  type: typeof CHANGE_APPLICATION_STATE;
  payload: {
    isWaiting: boolean;
  };
}

export interface PrepareAppAction {
  type: typeof PREPARE_APP_REQUEST;
}

export interface AppReadyAction {
  type: typeof APP_READY;
  payload: { 
    offert : OffertResponse, 
    billingCompany: string, 
    appId: string, 
    amountToPay: number, 
    successReturnUrl?: string;
    failureReturnUrl?: string; 
    applicationStatus: string; 
    workflowId: number;
    affiliatePartnerId: affiliatePartnersNames | null;
  };
}
export interface BankVerification {
  type: typeof BANK_VERIFICATION;
  payload: {
    isWaiting: boolean;
    kontomatikWidgetClient: string;
    kontomatikWidgetOwnerExternalId: string;
  };
}

export interface GetBmBanks{
  type: typeof GET_BM_BANKS;
  payload: BmBanksResponse[];
}

export interface ReturnFromBM{
  type: typeof RETURN_FROM_BM;
  payload: string;
}
export interface AppOfflineAction{
  type: typeof APP_OFFLINE;
}
export interface AppOnlineAction{
  type: typeof APP_ONLINE;
}
export interface AppBackOnlineAction{
  type: typeof APP_BACK_ONLINE;
}
export interface AppLoadingAction{
  type: typeof APP_LOADING;
}
export interface AppEndLoadingAction{
  type: typeof APP_END_LOADING;
}
export interface AppChangeLoadingScreenText {
  type: typeof APP_CHANGE_LOADING_SCREEN_TEXT;
  payload: string
}
export interface HubConnectedAction {
  type: typeof HUB_CONNECTED;
}

export interface HubDisconnectedAction {
  type: typeof HUB_DISCONNECTED;
}
export interface SetUserIsTrappedOnPageAction {
  type: typeof SET_USER_TRAPPED_ON_PAGE_URL_PATH;
  payload: keyof typeof AppLinks;
}
export interface SetContractDoneDataAction {
  type: typeof SET_CONTRACT_DONE_DATA;
  payload: IContractDone | IPreparedForDisbursed;
}
export interface SetHasClientConsentManualVerificationAction {
  type: typeof SET_HAS_CLIENT_CONSENT_MANUAL_VERIFICATION;
  payload: boolean;
}
export interface SetManualVerificationHubVerificationStateAction {
  type: typeof SET_MANUAL_VERIFICATION_HUB_VERIFICATION_STATE;
  payload: {
    manualVerificationPageVerificationState: MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES,
    workFrom: string
  };
}
export interface SetAppHasErrorAction {
  type: typeof SET_APP_HAS_ERROR;
}
export interface SetHubConnectionStatusAction {
  type: typeof SET_HUB_CONNECTION_STATUS;
  payload: IHubConnectionStatus;
}
export interface SetUserEmailFromHubAction {
  type: typeof SET_USER_EMAIL_FROM_HUB;
  payload: string;
}
export interface SetCurrentSelectedPRedefinedPeriodAction {
  type: typeof SET_CURRENT_SELECTED_PREDEFINED_PERIOD;
  payload: PREDEFINED_PERIODS_OFFER_LOGIC;
}
export interface SetIsPredefinedPeriodsAvailableAction {
  type: typeof SET_IS_PREDEFINED_PERIODS_AVAILABLE;
  payload: boolean
}


export type ApplicationActions =
  | ApplicationCreatedAction
  | ClearApplicationInfo
  | ChangeApplicationState
  | PrepareAppAction
  | PrepareAppAction
  | AppReadyAction
  | BankVerification
  | GetBmBanks
  | ReturnFromBM
  | AppOfflineAction
  | AppOnlineAction
  | AppBackOnlineAction
  | AppLoadingAction
  | AppEndLoadingAction
  | AppChangeLoadingScreenText
  | HubConnectedAction
  | HubDisconnectedAction
  | SetUserIsTrappedOnPageAction
  | SetContractDoneDataAction
  | SetHasClientConsentManualVerificationAction
  | SetManualVerificationHubVerificationStateAction
  | HubDisconnectedAction
  | SetAppHasErrorAction
  | SetHubConnectionStatusAction
  | SetUserEmailFromHubAction
  | SetCurrentSelectedPRedefinedPeriodAction
  | SetIsPredefinedPeriodsAvailableAction
